import React from "react";
import style from "./index.module.scss";
import { Icon, Tooltip } from "antd";
import { useSort } from "service/stores/Exercise/Statics";

export default function TopicListHeader() {
    const onSort = useSort();

    return (
        <div className={style.root} onClick={onSort}>
            正确率 &nbsp;
            <Tooltip title="此列表仅展示客观题的正确率，即单选题、多选题、判断题以及填空题的正确率，正确率= 作答正确人数 / 提交练习的人数 * 100%">
                <Icon type="exclamation-circle" className={style.notice} />
            </Tooltip>
        </div>
    );
}
